// extracted by mini-css-extract-plugin
export default {"tooltip":"Qo-z","sharingV2":"Ro-z","sharingIconsV2":"So-z","links":"To-z","link":"Uo-z","facebookV2":"Vo-z","twitterV2":"Wo-z","pinterestV2":"Xo-z"};